import SmartTipDescription from './SmartTipDescription';

export default SmartTipDescription;
